export namespace IProfileRequest {

  export enum Action {
    Get = 'contacts_get',
    Set = 'contacts_set',
  }

  export enum Command {
    Contacts = 'contacts',
    Password = 'password',
    Email = 'email',
    ConfirmEmail = 'confirmEmail',
    ClearNewVersion = 'clearNewVersion',
    SetExtModeFlag = 'setExtModeFlag',
    SetOfertaFlag = 'setOfertaFlag',
    Create = 'create',
  }
}
